"use client";

import { motion, useScroll } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import useMobile from "@/hooks/use-mobile";
import { generateWhatsAppLink } from "@/lib/generateWhatsappLink";

import HeaderContact from "./header-contact";
import { NavigationMenuApp } from "./navigation-menu";
import { MobileMenu } from "./navigation-menu-mobile";
//import { MobileMenu, MobileMenu, NavigationMenuMobileApp } from "./navigation-menu-mobile";

export function NavbarMain() {
  const isMobile = useMobile();

  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    return scrollY.on("change", (latest) => {
      setScrolled(latest > 50);
    });
  }, [scrollY]);

  return (
    <>
      <HeaderContact scrolled={false} />
      <motion.header
        initial={{
          y: !isMobile ? 0 : 0,
          borderRadius: "0",
          backgroundColor: "rgba(0,0,0,0.0)",
          width: "100%",
        }}
        animate={
          scrolled
            ? {
                y: 0,
                backgroundColor: "rgba(255,255,255,0.6)",
                width: "100%",
                top: 0,
              }
            : {
                y: !isMobile ? 0 : 0,
                backgroundColor: "rgba(0,0,0,0.0)",
                width: "100%",
              }
        }
        transition={{ duration: 0.6, ease: "easeInOut" }}
        className={`sticky top-0 left-0 z-50 w-full md:top-12 ${scrolled ? "top-0 shadow-lg backdrop-blur-sm" : ""} `}
      >
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div
            className={`flex items-center justify-center md:justify-between ${scrolled ? "h-18 md:h-24" : "h-18 md:h-26"} transition-all delay-150 ease-in`}
          >
            <MobileMenu />

            <Link href="/" className="flex items-center gap-2">
              <Image
                src="/logo-v2.png"
                alt="São Chico - Clinica Veterinária"
                width={800}
                height={500}
                className={`h-auto w-40 ${scrolled ? "md:w-50" : "md:w-50"}`}
                priority
                quality={100}
              />
            </Link>

            <NavigationMenuApp />

            <div className="hidden justify-end lg:flex">
              <Button size="xl" asChild>
                <Link
                  href={generateWhatsAppLink(
                    process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || "",
                    "Olá! Gostaria de mais informações sobre os serviços da Clínica São Chico.",
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="uppercaseflex items-center gap-2"
                >
                  <Image
                    src="/whatsapp-icon.svg"
                    alt="WhatsApp Icon"
                    width={20}
                    height={20}
                    className="h-5 w-5"
                  />{" "}
                  Agendar Agora
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </motion.header>
    </>
  );
}
